@if (app.field.getOptions(field).length > 0) {
  <div
    style="max-height: 250px; overflow-y: auto"
    >
    @for (option of app.field.getOptions(field); track option; let i = $index) {
      <div>
        @if (
          isMatch(searchText, app.field.getOptionDisplayText(field, option)) ||
          isMatch(searchText, app.field.getOptionText(field, option))
        ) {
          <button
            class="btn btn-sm"
      [ngClass]="{
        selected:
          app.field.isOptionSelected(field, option, model) &&
          !app.field.isMultiple(field)
      }"
      (click)="
        $event.stopPropagation();
        app.field.toggleOption(field, option, model);
        selected.next(option)
      "
            >
            @if (app.field.isMultiple(field) && app.filterList.field == null) {
              <input
                [checked]="app.field.isOptionSelected(field, option, model)"
                type="checkbox"
                />
            }
            <span
              tooltipClass="tree-category-tooltip"
              [ngbTooltip]="app.field.getOptionTooltipText(field, option)"
            >
              {{ app.field.getOptionDisplayText(field, option) }}
            </span>
          </button>
        }
      </div>
    }
  </div>
}
